import React from "react";
import { useNetwork } from "context/NetworkProvider";
import FullPageOffline from "components/FullPageOffline";

const NetworkGate = ({ children }) => {
  const { isOnline } = useNetwork();

  return (
    <>
      {children}
      {!isOnline && <FullPageOffline />}
    </>
  );
};

export default NetworkGate;
